import React from 'react'
import { getEmpresas, setEmpresa } from '../../store/actions/app.actions'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { useEffect,useState } from 'react'


export const SelectEmpresa = () => {

    const dispatch = useDispatch()
    const empresas = useSelector(state => state.app.empresas)
    const empresa  = useSelector(state => state.app.empresa)
    const data     = useSelector(state => state.login.data)
    

    const [emp, setEmp] = useState(empresa)



   useEffect(() => {
 
    dispatch(getEmpresas(data))


    }, [])




   useEffect(() => {

    if(!emp) return

    // const [empresa] = empresas.filter(item => item.value === emp.value)

    dispatch(setEmpresa(emp))
     
   }, [emp])




  return (
    <div className='selectEmpresa'>

            <p>Elegir Empresa</p>
            <Select options={empresas}   value={emp} onChange={setEmp} />
        
     </div>
  )
}
